import React, { createContext, useContext, useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const RouteContext = createContext();

export const useRouteHistory = () => {
  const context = useContext(RouteContext);
  if (!context) {
    throw new Error('useRouteHistory must be used within a RouteProvider');
  }
  return context;
};

export const RouteProvider = ({ children }) => {
  const [previousRoute, setPreviousRoute] = useState(null);
  const [previousRouteName, setPreviousRouteName] = useState(null);
  const location = useLocation();

  useEffect(() => {
    // Map routes to their display names
    const routeNameMap = {
      '/dashboards/overview': 'Overview',
      '/dashboards/takedowns': 'Takedowns',
      '/dashboards/platforms': 'Platforms',
      '/dashboards/threats': 'Threats',
      '/dashboards/reports': 'Weekly Reports',
      '/applications/submit': 'Submit Content',
      '/applications/reviewcontent': 'Review Content',
    };

    // Check if current route is a details page
    const isDetailsPage = location.pathname.includes('/details') || 
                         location.pathname.includes('/Details');

    if (isDetailsPage) {
      // Extract the parent route from the details page path
      const pathSegments = location.pathname.split('/');
      let parentRoute = null;
      let parentRouteName = null;

      if ((location.pathname.includes('/dashboards/takedowns/') || location.pathname.includes('/Dashboards/Takedowns/')) && location.pathname.includes('/Details')) {
        parentRoute = '/dashboards/takedowns';
        parentRouteName = 'Takedown Dashboard';
      } else if (location.pathname.includes('/dashboards/platforms/') && location.pathname.includes('/details')) {
        parentRoute = '/dashboards/platforms';
        parentRouteName = 'Platform Dashboard';
      } else if (location.pathname.includes('/dashboards/threats/') && location.pathname.includes('/details')) {
        parentRoute = '/dashboards/threats';
        parentRouteName = 'Threat Dashboard';
      }

      setPreviousRoute(parentRoute);
      setPreviousRouteName(parentRouteName);
    } else {
      // For non-details pages, we could track the actual previous route
      // For now, we'll just clear the previous route
      setPreviousRoute(null);
      setPreviousRouteName(null);
    }
  }, [location.pathname]);

  const value = {
    previousRoute,
    previousRouteName,
    isDetailsPage: location.pathname.includes('/details') || location.pathname.includes('/Details'),
  };

  return (
    <RouteContext.Provider value={value}>
      {children}
    </RouteContext.Provider>
  );
};
